var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAave = function SvgAave(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 190.5 190.5"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9391F7",
    d: "M190.5 95.3C190.5 42.6 147.9 0 95.3 0S0 42.6 0 95.3s42.6 95.3 95.3 95.3 95.2-42.7 95.2-95.3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M77.5 99.9c8.2-1.3 13.7-9 12.4-17.2s-9-13.7-17.2-12.4-13.7 9-12.4 17.2c1.4 8.2 9.1 13.7 17.2 12.4m39.2 0c8.2-1.3 13.7-9 12.4-17.2s-9-13.7-17.2-12.4-13.7 9-12.4 17.2 9 13.7 17.2 12.4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M94.7 23.3C54 23.3 21 56.9 21 98.3h18.8c0-31.1 24.4-56.2 54.8-56.2 30.5 0 54.8 25.2 54.8 56.2h18.8c.2-41.4-32.8-75-73.5-75"
  })));
};
export default SvgAave;